/* eslint-disable no-restricted-syntax */
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import { useSelector } from 'react-redux';
import SiteLogo from '@Components/SiteLogo';
import { resolveDefaultPrivatePath } from '../../routers/private/defaultRoute';

function PageErrorPermission() {
  const history = useHistory();
  const accessPermisions = useSelector((state) => state.user.accessPermisions);
  const userInfo = useSelector((state) => state.user.info);

  const backToHomePage = () => {
    const defaultPrivatePath = resolveDefaultPrivatePath(accessPermisions, userInfo, '/dashboard');
    history.replace(defaultPrivatePath);
  };
  return (
    <div>
      <div className="d-flex justify-content-center pt-2">
        <SiteLogo width="260" />
      </div>
      <div className="container">
        <div className="content-public-wrapper">
          <div className="d-flex justify-content-center">
            <div>
              <img src="/images/not-permission.png" alt="not permission" />
              <p className="text-center pt-3 pb-1">Bạn không có quyền truy cập trang này.</p>
              <div className="w-100 text-center">
                <Button
                  color="primary"
                  className="btn btn-primary py-15p px-40p"
                  onClick={() => backToHomePage()}
                >
                  Về trang chủ
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

PageErrorPermission.propTypes = {};

export default PageErrorPermission;
